<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Stowage</h3>
            </div>
        </div>
        <div class="card">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-6">
                        <div class="form-field">
                            <input-field :readonly="form.estado != 'N'" v-model="form.subcode" id="code" placeholder="##">
                                <span>Subcode</span>
                                <span v-if="errores.subcode" class="helper-text text-danger" slot="helper">
                                    <strong>{{ errores.subcode[0] }}</strong>
                                </span>
                            </input-field>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="form-field">
                            <input-field v-model="form.code" id="code" placeholder="##">
                                <span>Code</span>
                                <span v-if="errores.code" class="helper-text text-danger" slot="helper">
                                    <strong>{{ errores.code[0] }}</strong>
                                </span>
                            </input-field>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select @input="inputCustomer" id="customer_code" v-model="selectedCustomer" :options="customers" label="name"></v-select>
                                <label for="customer_code">Cliente</label>
                                 <span v-if="errores.customer_code" class="helper-text text-danger" slot="helper">
                                    <strong>{{ errores.customer_code[0] }}</strong>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="aceptar" class="btn-success" type="button"><i class="fa fa-save"></i><span>Guardar</span></button>
            <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button"><i class="fa fa-ban"></i><span>Cancelar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        customers: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        },
        value : {
            type : Object,
            required : false, 
            default : function () {
                return {
                    subcode : '',
                    code : '',
                    customer_code : '',
                    estado: 'N'
                };
            }
        }
    },
    data : function () {
        return {
            form : this.value,
            errores : {},
            url : url,
            selectedCustomer: null
        }
    },
    methods : {
        inputCustomer: function () {
            if (this.selectedCustomer != null)
                this.form.customer_code = this.selectedCustomer.code;
            else 
                this.form.customer_code = '';
        },
        aceptar : function () {
            let urlRequest = this.url + '/stowage';
            if (this.form.estado !== 'N')
            {
                urlRequest += '/' + this.form.subcode;
                this.form._method = 'PUT';
            }
            else 
                this.form._method = undefined;
            let that = this;
            axios.post(urlRequest, this.form).then(function (response) {
                swal(that.$t('message.saved'), that.$t('message.aviso'), 'success');
                that.$emit('saved', response.data);
            }).catch(function (error) {
                if (error !== undefined && error !== null) {
                    let response = error.response;
                    if (response !== undefined && response !== null) {
                        let status = response.status;
                        if (status === 422) {
                            that.errores = response.data.errors;
                            swal(that.$t('message.errorValidacion'), that.$t('message.aviso'), 'warning');
                        }
                        else 
                            swal(that.$t('message.errorText'), that.$t('message.error'), 'error');
                    }
                }
            })
        }
    },
    mounted: function () {
        for (let i = 0; i < this.customers.length; i++) {
            if (this.customers[i].code == this.form.customer_code) {
                this.selectedCustomer = this.customers[i];
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/stowage/Stowage.vue